import { render } from "./EditVendor.vue?vue&type=template&id=79737066&scoped=true"
import script from "./EditVendor.vue?vue&type=script&lang=js"
export * from "./EditVendor.vue?vue&type=script&lang=js"

import "./EditVendor.vue?vue&type=style&index=0&id=79737066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79737066"]])

export default __exports__